(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('classnames/bind')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'classnames/bind'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.core = {}, global.React, global.classNames));
})(this, (function (exports, React, classNames) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var React__namespace = /*#__PURE__*/_interopNamespace(React);
  var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

  var styles = {"footer":"Footer_footer__NGm3A","btns":"Footer_btns__mfPDb","service":"Footer_service__r5u53","anchor":"Footer_anchor__soMtx","limitation":"Footer_limitation__To1W3","business":"Footer_business__OvbUE","summary":"Footer_summary__J-7Ys","address":"Footer_address__Vmnb4","list":"Footer_list__6j0Ag","title":"Footer_title__qVVE-","detail":"Footer_detail__hzrnA","nav":"Footer_nav__Cm24I","row":"Footer_row__FwRK8","company":"Footer_company__uiiQU"};

  classNames__default["default"].bind(styles);

  var cx$6 = classNames__default["default"].bind(styles);
  /**
   * `navigations`를 채우는 anchor tag입니다.
   *
   * @props url - anchor tag의 href
   * @props children - 컴포넌트의 children
   * @props onClick - anchor tag의 onClick
   *
   */
  var Item = function (_a) {
      var url = _a.url, children = _a.children, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
      return (React__default["default"].createElement("a", { className: cx$6("anchor"), href: url, onClick: onClick }, children));
  };

  var cx$5 = classNames__default["default"].bind(styles);
  /**
   * 767px 보다 작은 사이즈에서 한 줄로 표시되는 네비게이션의 컨테이너입니다.
   *
   * @param children - 네비게이션 아이템들
   */
  var Row = function (_a) {
      var children = _a.children;
      return React__default["default"].createElement("div", { className: cx$5("row") }, children);
  };

  var _g$1;
  function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
  var SvgFooterTop = function SvgFooterTop(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
      xmlns: "http://www.w3.org/2000/svg",
      width: 11,
      height: 18
    }, props), _g$1 || (_g$1 = /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 18V0h11v18z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      stroke: "#5398F5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m.5 6.5 5-5 5 5m-5 8v-12"
    }))));
  };

  var _g;
  function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
  var SvgFooterShare = function SvgFooterShare(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
      xmlns: "http://www.w3.org/2000/svg",
      width: 18,
      height: 15
    }, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
      fill: "#5398F5"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.8 2.826V.539c0-.389.5-.588.801-.32l4.605 4.094a.42.42 0 0 1 0 .639l-4.605 4.094c-.301.268-.801.069-.801-.32V6.439H9.762c-1.555 0-2.745.432-3.633 1.15-.308.25-.557.516-.75.78-.113.155-.18.27-.206.325-.218.456-.954.279-.906-.218.305-3.212 2.503-5.65 5.596-5.65H11.8zm4.391 1.806-3.443-3.06v1.696c0 .244-.212.442-.474.442h-2.41c-1.988 0-3.55 1.253-4.263 3.138 1.046-.81 2.425-1.293 4.161-1.293h2.512c.262 0 .474.198.474.442v1.696l3.443-3.06z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.996 13.996v-3.408h1v4.408H0V3.003h4.912v1H1v9.993z"
    }))));
  };

  var _path;
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var SvgFooterSummary = function SvgFooterSummary(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: 8,
      height: 6
    }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#A7AAAC",
      d: "m.72.789-.72.76 3.985 4.208L8 1.517l-.72-.76-3.295 3.48z"
    })));
  };

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                  t[p[i]] = s[p[i]];
          }
      return t;
  }

  typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
      var e = new Error(message);
      return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
  };

  var development = {
      env: 'development',
      url: {
          cdn: 'https://vertical.pstatic.net',
          hotel: 'https://test-hotels.naver.com',
          flight: 'https://test-flight.naver.com',
          pkgtour: 'https://test-pkgtour.naver.com',
          travel4u: 'https://test-travel4u.naver.com',
          tour: 'http://test-m-tour.store.naver.com:11111/local',
          eventpromotion: 'https://test-travel-event.naver.com',
          mypage: 'https://test-travel.naver.com/my',
          travelsearch: 'https://test-travel.naver.com',
          bizflight: 'http://dev.store.naver.com:3000/flights',
          bizflightApi: 'http://dev-flight-front.naver.com',
          bizhotel: 'https://dev.store.naver.com:3000/hotels',
          biztrip: 'https://dev-biztrip.naver.com',
          biztripschedule: 'https://dev-biztrip.naver.com/traveler/business-travel',
          biztripbooking: 'https://dev-biztrip.naver.com/traveler/reservation',
          biztripreport: 'https://dev-biztrip.naver.com/traveler/expense-report',
          bizmypage: 'https://dev-biztrip.naver.com/mypage',
          bizmanage: 'https://dev-biztrip.naver.com/home/manager',
          biztraveler: 'https://dev-biztrip.naver.com/home/traveler',
          photoInfra: 'https://phinf.pstatic.net/dbscthumb',
          bizhotelApi: 'https://test-biz-hotel-api.naver.com',
      },
      splugin: {
          mobile: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.m.js',
          pc: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.js',
      },
  };

  var test = {
      env: 'test',
      url: {
          cdn: 'https://vertical.pstatic.net',
          hotel: 'https://test-hotels.naver.com',
          flight: 'https://test-flight.naver.com',
          pkgtour: 'https://test-pkgtour.naver.com',
          travel4u: 'https://test-travel4u.naver.com',
          tour: 'http://test-m-tour.store.naver.com:11111/local',
          eventpromotion: 'https://test-travel-event.naver.com',
          mypage: 'https://test-travel.naver.com/my',
          travelsearch: 'https://test-travel.naver.com',
          bizflight: 'https://dev-biztrip.naver.com/flights',
          bizflightApi: 'https://dev-flight-front.naver.com',
          bizhotel: 'https://dev.store.naver.com:3000/hotels',
          biztrip: 'https://dev-biztrip.naver.com',
          biztripschedule: 'https://dev-biztrip.naver.com/traveler/business-travel',
          biztripbooking: 'https://dev-biztrip.naver.com/traveler/reservation',
          biztripreport: 'https://dev-biztrip.naver.com/traveler/expense-report',
          bizmypage: 'https://dev-biztrip.naver.com/mypage',
          bizmanage: 'https://dev-biztrip.naver.com/home/manager',
          biztraveler: 'https://dev-biztrip.naver.com/home/traveler',
          photoInfra: 'https://phinf.pstatic.net/dbscthumb',
          bizhotelApi: 'https://test-biz-hotel-api.naver.com',
      },
      splugin: {
          mobile: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.m.js',
          pc: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.js',
      },
  };

  var stage = {
      env: 'stage',
      url: {
          cdn: 'https://vertical.pstatic.net',
          hotel: 'https://stage-hotels.naver.com',
          flight: 'https://stage-flight.naver.com',
          pkgtour: 'https://stage-pkgtour.naver.com',
          travel4u: 'https://stage-travel4u.naver.com',
          tour: 'https://stage-m-tour.store.naver.com/local',
          eventpromotion: 'https://stage-travel-event.naver.com',
          mypage: 'https://stage-travel.naver.com/my',
          travelsearch: 'https://stage-travel.naver.com',
          bizflight: 'https://stage-biztrip.naver.com/flights',
          bizflightApi: 'https://stage-flight-front.naver.com',
          bizhotel: 'https://stage-biztrip.naver.com/hotels',
          biztrip: 'https://stage-biztrip.naver.com',
          biztripschedule: 'https://stage-biztrip.naver.com/traveler/business-travel',
          biztripbooking: 'https://stage-biztrip.naver.com/traveler/reservation',
          biztripreport: 'https://stage-biztrip.naver.com/traveler/expense-report',
          bizmypage: 'https://stage-biztrip.naver.com/mypage',
          bizmanage: 'https://stage-biztrip.naver.com/home/manager',
          biztraveler: 'https://stage-biztrip.naver.com/home/traveler',
          photoInfra: 'https://phinf.pstatic.net/dbscthumb',
          bizhotelApi: 'https://stage-biz-hotel-api.naver.com',
      },
      splugin: {
          mobile: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.m.js',
          pc: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.js',
      },
  };

  var production = {
      env: 'production',
      url: {
          cdn: 'https://vertical.pstatic.net',
          hotel: 'https://hotels.naver.com',
          flight: 'https://flight.naver.com',
          pkgtour: 'https://pkgtour.naver.com',
          travel4u: 'https://travel4u.naver.com',
          tour: 'https://m-tour.store.naver.com/local',
          eventpromotion: 'https://travel-event.naver.com',
          mypage: 'https://travel.naver.com/my',
          travelsearch: 'https://travel.naver.com',
          bizflight: 'https://biztrip.naver.com/flights',
          bizflightApi: 'https://flight-front.naver.com',
          bizhotel: 'https://biztrip.naver.com/hotels',
          biztrip: 'https://biztrip.naver.com',
          biztripschedule: 'https://biztrip.naver.com/traveler/business-travel',
          biztripbooking: 'https://biztrip.naver.com/traveler/reservation',
          biztripreport: 'https://biztrip.naver.com/traveler/expense-report',
          bizmypage: 'https://biztrip.naver.com/mypage',
          bizmanage: 'https://biztrip.naver.com/home/manager',
          biztraveler: 'https://biztrip.naver.com/home/traveler',
          photoInfra: 'https://phinf.pstatic.net/dbscthumb',
          bizhotelApi: 'https://biz-hotel-api.naver.com',
      },
      splugin: {
          mobile: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.m.js',
          pc: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.js',
      },
  };

  var commonConfig = {
      nAuthWithUrlParam: "https://nid.naver.com/nidlogin.login?svctype=262144&url=",
  };

  var _a;
  var configMap = new Map([
      ["development", development],
      ["test", test],
      ["stage", stage],
      ["production", production],
  ]);
  var env = process.env.APP_ENV || process.env.NODE_ENV;
  if (typeof window !== 'undefined') {
      env = ((_a = window === null || window === void 0 ? void 0 : window.__ENV) === null || _a === void 0 ? void 0 : _a.APP_ENV) || env;
  }
  var envConfig = configMap.get(env || "development") ||
      development;
  var config = __assign(__assign({}, envConfig), commonConfig);

  var loadScript = function (onload) {
      var script = document.createElement("script");
      var version = Math.floor(new Date().getTime() / 1200000);
      script.src = "".concat(config.splugin.mobile, "?v=").concat(version);
      script.onload = onload;
      document.body.appendChild(script);
  };
  var initNaverSplugin = function (evKey, serviceName) {
      if (!(window === null || window === void 0 ? void 0 : window.SocialPlugIn_Core)) {
          loadScript(function () {
              window.__splugin = window.SocialPlugIn_Core({
                  evKey: evKey,
                  serviceName: serviceName,
                  source: "empty",
              });
          });
          return;
      }
      window.__splugin = window.SocialPlugIn_Core({
          evKey: evKey,
          serviceName: serviceName,
          source: "empty",
      });
  };
  var addNaverSplugin = function (elButton) {
      if (elButton)
          window.__splugin.init(elButton);
  };
  var removeNaverSplugin = function (elButton) {
      if (elButton && (window === null || window === void 0 ? void 0 : window.__splugin))
          window.__splugin.kill(elButton);
  };

  var cx$4 = classNames__default["default"].bind(styles);
  /**
   * `topSectionButtons`를 채우는 버튼 컴포넌트입니다. `button`에서 사용하는 모든 prop을 그대로 사용할 수 있고, css만 설정되어 있는 상태입니다.
   *
   * @props children - 버튼에 표시될 텍스트
   * @props className - 컴포넌트에 추가할 클래스 이름
   * @props 기타 - button에서 사용하는 모든 prop을 그대로 사용할 수 있습니다.
   *
   */
  var TopSectionButton = React.forwardRef(function (_a, ref) {
      var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
      return (React__default["default"].createElement("button", __assign({ type: "button", className: cx$4("btn", className) }, restProps, { ref: ref }), children));
  });

  var cx$3 = classNames__default["default"].bind(styles);
  /**
   * `TopSectionButtons`를 사용해 생성한 공유하기 버튼입니다.
   *
   * @props eventKey - 공유하기 이벤트 키 ex) hotel
   * @props serviceName - 서비스명. "출처: {serviceName}"으로 노출.
   * @props sourceName - 출처명. "출처:{sourceName} | {serviceName}"으로 노출.
   * @props title
   * @props onClick - 클릭 이벤트 핸들러 (event) => void
   */
  var ShareButton = function (_a) {
      var eventKey = _a.eventKey, serviceName = _a.serviceName, sourceName = _a.sourceName, title = _a.title, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
      var buttonShare = React.useRef(null);
      React.useEffect(function () {
          if (!(window === null || window === void 0 ? void 0 : window.__splugin))
              initNaverSplugin(eventKey, serviceName);
          else
              addNaverSplugin(buttonShare.current);
          return function () {
              removeNaverSplugin(buttonShare.current);
          };
      }, []);
      return (React__default["default"].createElement(TopSectionButton, { ref: buttonShare, className: cx$3("as_share naver-splugin spi_sns_share"), "data-evkey": eventKey, "data-service-name": serviceName, "data-source-name": sourceName, "data-title": title, "data-option": JSON.stringify({
              layerPosition: "outside-bottom",
              align: "right",
          }), onClick: onClick },
          React__default["default"].createElement(SvgFooterShare, { className: "svg" }),
          "\uACF5\uC720\uD558\uAE30"));
  };

  var useIsLogin = function () {
      var _a = React.useState(false), isLogin = _a[0], setIsLogin = _a[1];
      React.useEffect(function () {
          setIsLogin(document.cookie.includes("NID_SES="));
      }, []);
      return isLogin;
  };

  var useCurrentUrl = function () {
      var _a = React.useState(), location = _a[0], setLocation = _a[1];
      React.useEffect(function () {
          setLocation(window.location.href);
      }, []);
      return location;
  };

  var cx$2 = classNames__default["default"].bind(styles);
  /**
   * `middleSectionButtons`를 채우는 버튼 컴포넌트입니다. `button`에서 사용하는 모든 prop을 그대로 사용할 수 있고, css만 설정되어 있는 상태입니다.
   *
   * @props children - 버튼에 표시될 텍스트
   * @props className - 컴포넌트에 추가할 클래스 이름
   * @props 기타 - button에서 사용하는 모든 prop을 그대로 사용할 수 있습니다.
   */
  var MiddleSectionButton = React.forwardRef(function (_a, ref) {
      var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
      return (React__default["default"].createElement("a", __assign({ className: cx$2("anchor", className) }, restProps, { ref: ref }), children));
  });

  var LoginButton = function (_a) {
      var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
      var location = useCurrentUrl();
      var loginLink = location
          ? "https://nid.naver.com/nidlogin.login?svctype=262144&url=".concat(encodeURIComponent(location))
          : "#none";
      return (React__default["default"].createElement(MiddleSectionButton, { href: loginLink, onClick: onClick }, "\uB85C\uADF8\uC778"));
  };

  var LogoutButton = function (_a) {
      var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
      var location = useCurrentUrl();
      var logoutLink = location
          ? "https://nid.naver.com/nidlogin.logout?svctype=262144&returl=".concat(encodeURIComponent(location))
          : "#none";
      return (React__default["default"].createElement(MiddleSectionButton, { href: logoutLink, onClick: onClick }, "\uB85C\uADF8\uC544\uC6C3"));
  };

  var LoginOutButton = function (_a) {
      var onLoginClick = _a.onLoginClick, onLogoutClick = _a.onLogoutClick;
      var isLogin = useIsLogin();
      if (isLogin) {
          return React__default["default"].createElement(LogoutButton, { onClick: onLogoutClick });
      }
      return React__default["default"].createElement(LoginButton, { onClick: onLoginClick });
  };

  var cx$1 = classNames__default["default"].bind(styles);
  /**
   * TopSectionButtons를 사용해 생성한 "맨위로" 버튼입니다.
   *
   * @props onClick - 클릭 이벤트 핸들러 (event) => void
   */
  var ScrollTopButton = function (_a) {
      var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
      var scrollTop = function () {
          window.scrollTo(0, 0);
      };
      return (React__default["default"].createElement(TopSectionButton, { className: cx$1("as_top"), onClick: function (event) {
              onClick(event);
              scrollTop();
          } },
          React__default["default"].createElement(SvgFooterTop, { className: "svg" }),
          "\uB9E8\uC704\uB85C"));
  };

  var businessDetail = {
      ceo: '최수연',
      address: '경기도 성남시 분당구 정자일로 95',
      addressDetail: 'NAVER 1784, 13561',
      phone: '1588-3820(대표전화/고객센터)',
      email: 'ccnaver@naver.com',
      licenseNumber: '220-81-62517',
      MailOrderSailsReportNumber: '2006-경기성남-0692',
      hostingService: 'NAVER Cloud',
  };

  var cx = classNames__default["default"].bind(styles);
  /**
   * 사업자 정보를 보여주는 컴포넌트입니다.
   *
   * @props onClick - summary를 클릭했을 때 호출되는 클릭 이벤트 핸들러 (event) => void
   */
  var BusinessDetails = function (_a) {
      var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
      var _c = React.useState(false), isShowSummary = _c[0], setIsShowSummary = _c[1];
      return (React__default["default"].createElement("details", { className: cx('business') },
          React__default["default"].createElement("summary", { className: cx('summary'), onClick: function (event) {
                  onClick(event);
                  setIsShowSummary(function (prev) { return !prev; });
              } },
              "\uB124\uC774\uBC84\u321C \uC0AC\uC5C5\uC790 \uC815\uBCF4",
              React__default["default"].createElement(SvgFooterSummary, { className: cx('svg') })),
          isShowSummary && (React__default["default"].createElement("address", { className: cx('address') },
              React__default["default"].createElement("dl", { className: cx('list') },
                  React__default["default"].createElement("dt", { className: cx('title') }, "\uB300\uD45C\uC774\uC0AC"),
                  React__default["default"].createElement("dd", { className: cx('detail') }, businessDetail.ceo),
                  React__default["default"].createElement("dt", { className: cx('title') }, "\uC8FC\uC18C"),
                  React__default["default"].createElement("dd", { className: cx('detail') },
                      businessDetail.address,
                      React__default["default"].createElement("br", null),
                      businessDetail.addressDetail),
                  React__default["default"].createElement("dt", { className: cx('title') }, "\uC804\uD654"),
                  React__default["default"].createElement("dd", { className: cx('detail') }, businessDetail.phone),
                  React__default["default"].createElement("dt", { className: cx('title') }, "\uC774\uBA54\uC77C"),
                  React__default["default"].createElement("dd", { className: cx('detail') }, businessDetail.email),
                  React__default["default"].createElement("dt", { className: cx('title') }, "\uC0AC\uC5C5\uC790 \uB4F1\uB85D\uBC88\uD638"),
                  React__default["default"].createElement("dd", { className: cx('detail') }, businessDetail.licenseNumber),
                  React__default["default"].createElement("dt", { className: cx('title') }, "\uD1B5\uC2E0\uD310\uB9E4\uBC88\uD638"),
                  React__default["default"].createElement("dd", { className: cx('detail') }, businessDetail.MailOrderSailsReportNumber),
                  React__default["default"].createElement("dt", { className: cx('title') }, "\uD638\uC2A4\uD305 \uC11C\uBE44\uC2A4 \uC81C\uACF5"),
                  React__default["default"].createElement("dd", { className: cx('detail') }, businessDetail.hostingService))))));
  };

  exports.BusinessDetails = BusinessDetails;
  exports.LoginOutButton = LoginOutButton;
  exports.MiddleSectionButton = MiddleSectionButton;
  exports.NavItem = Item;
  exports.NavRow = Row;
  exports.ScrollTopButton = ScrollTopButton;
  exports.ShareButton = ShareButton;
  exports.TopSectionButton = TopSectionButton;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
